const { Criteria } = Shopware.Data;

const FLOWS = { flavor: 'Aromenberater', device: 'Geräteberater' };

export default {
    template: `
<sw-page class="riccardo-advisor-list">
    <template #smart-bar-header><h2>Berater – Fragen</h2></template>
    <template #smart-bar-actions>
        <sw-button :router-link="{ name: 'riccardo.advisor.create', params: { flow: 'flavor' } }">Frage für Aromenberater</sw-button>
        <sw-button variant="primary" :router-link="{ name: 'riccardo.advisor.create', params: { flow: 'device' } }">Frage für Geräteberater</sw-button>
    </template>
    <template #content>
        <div style="padding: 24px;">
            <sw-card v-for="(label, flow) in flows" :key="flow" :title="label" :is-loading="isLoading">
                <p style="color:#798490">
                    Reihenfolge über „Position“. Vorschau:
                    <a :href="flow === 'device' ? '/geraeteberater' : '/aromenberater'" target="_blank" rel="noopener">{{ flow === 'device' ? '/geraeteberater' : '/aromenberater' }}</a>
                </p>
                <sw-data-grid v-if="questions" :data-source="byFlow(flow)" :columns="columns" :show-selection="false" :compact-mode="true" @column-sort="() => {}">
                    <template #column-title="{ item }">
                        <router-link :to="{ name: 'riccardo.advisor.detail', params: { id: item.id } }"><strong>{{ item.title }}</strong></router-link>
                        <div style="color:#798490">{{ item.subtitle }}</div>
                    </template>
                    <template #column-options="{ item }">{{ (item.options || []).length }} Antworten</template>
                    <template #column-multiple="{ item }">{{ item.multiple ? 'Mehrfachauswahl' : 'Einfachauswahl' }}{{ item.required ? ' · Pflicht' : '' }}</template>
                    <template #column-active="{ item }">
                        <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-s'" :color="item.active ? '#37d046' : '#de294c'" small />
                    </template>
                    <template #actions="{ item }">
                        <sw-context-menu-item :router-link="{ name: 'riccardo.advisor.detail', params: { id: item.id } }">Bearbeiten</sw-context-menu-item>
                        <sw-context-menu-item variant="danger" @click="onDelete(item)">Löschen</sw-context-menu-item>
                    </template>
                </sw-data-grid>
            </sw-card>
        </div>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    data() {
        return { questions: null, isLoading: false, flows: FLOWS };
    },

    computed: {
        questionRepository() {
            return this.repositoryFactory.create('riccardo_advisor_question');
        },
        columns() {
            return [
                { property: 'position', label: 'Pos.', width: '70px' },
                { property: 'title', label: 'Frage', primary: true },
                { property: 'options', label: 'Antworten' },
                { property: 'multiple', label: 'Auswahl' },
                { property: 'active', label: 'Aktiv', align: 'center', width: '80px' },
            ];
        },
    },

    created() {
        this.getList();
    },

    methods: {
        byFlow(flow) {
            return (this.questions || []).filter((question) => question.flow === flow);
        },

        getList() {
            this.isLoading = true;
            const criteria = new Criteria(1, 100);
            criteria.addAssociation('options');
            criteria.addSorting(Criteria.sort('position', 'ASC'));
            return this.questionRepository.search(criteria).then((result) => {
                this.questions = result;
            }).finally(() => { this.isLoading = false; });
        },

        onDelete(item) {
            return this.questionRepository.delete(item.id).then(() => this.getList());
        },
    },
};
